var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsfireexitinguisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-572-382H578v754H-572z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.473 33.118h-2.518V29.94h-2.353v5.53h4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M89.215 30.968v-4.547H69.32a8.424 8.424 0 0 0-4.334-1.203 8.486 8.486 0 0 0-7.392 4.333h-9.437v2.062c-3.528.566-6.235 3.623-6.235 7.309v46.937h-2.588v12.082h7.53v-12.08h-2.59V38.922c0-2.383 1.662-4.373 3.883-4.907v1.808h8.621a8.462 8.462 0 0 0 1.875 3.511v3.222c-4.52 2.354-7.4 7.052-7.4 12.177v49.523H78.72V54.734c0-5.124-2.88-9.823-7.4-12.177v-3.221c.056-.062.114-.12.168-.184l15.963 2.39v-5.286l-13.979-2.588c0-.186-.016-.37-.028-.552l15.771-2.148zM44.51 95.588h-2.823v-7.375h2.823v7.375zm42.353-66.674l-13.91 1.893a8.443 8.443 0 0 0-1.071-2.033h14.981v.14zm-21.876-1.343a6.142 6.142 0 0 1 6.135 6.135 6.142 6.142 0 0 1-6.135 6.134 6.142 6.142 0 0 1-6.134-6.134 6.142 6.142 0 0 1 6.134-6.135zM50.51 31.904h6.187c-.11.507-.17 1.03-.185 1.567H50.51v-1.567zm3.097 38.978V58.53h22.761v12.353H53.606zm22.761 2.353v5.177H53.606v-5.177h22.761zm-22.761 28.67v-21.14h22.761v21.14H53.606zm22.761-47.171v1.442H53.606v-1.442c0-4.459 2.632-8.528 6.707-10.368l.692-.313v-2.856a8.427 8.427 0 0 0 3.98.996 8.424 8.424 0 0 0 3.98-.996v2.856l.692.313a11.4 11.4 0 0 1 6.71 10.368zm8.73-15.923l-12.28-1.84c.133-.313.239-.638.332-.97l11.948 2.213v.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.45 83.706h2.353v10.471H71.45zM71.45 95.588h2.353v3.882H71.45zM71.45 59.941h2.353V69H71.45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsfireexitinguisher);
export default __webpack_public_path__ + "static/media/iconsfireexitinguisher.8aa8a866477d07a730442b4db675ff61.svg";
export { ForwardRef as ReactComponent };